import { IEmailEntityType } from "./index";

export interface IEmailTemplatePreview {
    entityTypes: IEmailEntityType[],
    emailAddress: string
}